import {User} from '@/store/modules/user/types';
import router from '@/router';
import axios from '@/requests';

export interface UserLoginMsg {
    username: string,
    password: string,
    otpCode: string,
}

export interface UserReq {
    username: string,
    priv: number,
    password: string,
    isPermanent: boolean,
    expiredTime: string,
    moduleList: string,
}
export interface UserReqUpdate {
    id: number,
    username: string,
    priv: number,
    password: string,
    isPermanent: boolean,
    expiredTime: string,
    moduleList: string,
}
export interface ModuleListReq {
    userId: number,
    projId: string,
    uid: string,
}

export const userAPI = {
    async login(loginMsg: UserLoginMsg): Promise<User> {
        try {
            return await axios.post<User>('/user/login', loginMsg);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async checkIsOtpCodeExist(loginMsg: UserLoginMsg): Promise<boolean | string> {
        try {
            return await axios.post<boolean | string>('/user/checkIsOtpCodeExist', loginMsg);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async logout(): Promise<boolean> {
        try {
            await axios.get<void>('/user/logout', {});
            await router.push("login");
            return true;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getUserList(): Promise<User[]> {
        try {
            return await axios.get<User[]>('/user/listUser', {});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async createUser(createMsg: UserReq): Promise<User> {
        try {
            return await axios.post<User>('/user/addUser', createMsg);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async deleteUser(id: number): Promise<User> {
        try {
            return await axios.get<User>('/user/delUser', {"id": id});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async updateUser(userReq: UserReqUpdate): Promise<User> {
        try {
            return await axios.post<User>('/user/updateUser', userReq);
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async showOwnInfo(): Promise<User> {
        try {
            return await axios.get<User>('/user/showOwnInfo', {});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async GetModuleListByUserAndProjIdAndTargetId(moduleListReq: ModuleListReq) {
        try {
            return await axios.get<string>('/user/getModuleListByUserAndProjIdAndTargetId', moduleListReq);
        } catch (err) {
            return Promise.reject(err);
        }
    },

}

const dummyWait = (ms: number) => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    })
}

